<div class="modal-header navbar-alertia">
    <h4 class="modal-title">{{'alert.alert-status' | translate}}</h4>
    <button tabindex="0" type="button" title="{{ 'general.close_window' | translate }}" class="close" (click)="activeModal.close(false)">&times;</button>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-12">
            <p>{{message | translate:{alertId: this.alertId, name: this.userName, attempts: this.attempts} }}</p>
            <p *ngIf = "this.firstAgent != ''">{{'alert_activity.first_agent' | translate}} {{this.firstAgent}}</p> 
            <p *ngIf = "this.secondAgent != ''">{{'alert_activity.second_agent' | translate}} {{this.secondAgent}}</p>
            <p *ngIf = "this.thirdAgent != ''">{{'alert_activity.third_agent' | translate}} {{this.thirdAgent}}</p>
            <p>{{'alert_activity.dispatch_message_end' | translate}}</p>
        </div>
    </div>
</div>
<div class="modal-footer text-right">
    <ng-template #activeAlertButton>
        <button type="button" title="{{ 'general.view' | translate }}" class="btn btn-blue btn-h-blue" [routerLink]="['main/activeAlerts/view-alert', alertId]" routerLinkActive="active" (click)="activeModal.close(false)">
            {{ 'general.view' | translate }}
        </button>
    </ng-template>
    
</div>
